import React, { useEffect, useReducer, useState } from 'react'
import useSWR from 'swr'
import { useTranslation } from 'react-i18next'
import { ProtectedPage } from '~/src/components/templates'
import {
  HeaderStatementOfAccountList,
  TableStatementOfAccountList,
} from '~/src/components/organisms/StatementOfAccount'
import { LoadingNormal } from '~/src/components/organisms'
import { orderRepository } from '~/src/repositories'
import { useMessage } from '~/src/hooks'
import { useLocation, useNavigate, createSearchParams } from 'react-router-dom'

type Params = {
  limit: number
  offset?: number
  keyword?: string
  userId?: number
}

enum ActionType {
  SET_OFFSET,
  SET_KEYWORD,
  SET_USER_ID,
}

type Action = {
  type: ActionType
  payload: Partial<Params>
}

const reducer = (state: Params, action: Action): Params => {
  switch (action.type) {
    case ActionType.SET_OFFSET:
      return { ...state, offset: action.payload.offset }
    case ActionType.SET_KEYWORD:
      return { ...state, offset: 1, keyword: action.payload.keyword, userId: undefined } //コンテナ詳細から遷移後にkeyword検索したときにuserIdをparamに含めない
    case ActionType.SET_USER_ID:
      return { ...state, offset: 1, userId: action.payload.userId }
  }
}

/**
 * OrderStatementOfAccountList
 * Statement Of Account
 */
export const OrderStatementOfAccountList: React.VFC = (): JSX.Element => {
  const { t } = useTranslation()
  const { handleOpenWithErrorMessage } = useMessage()
  const navigate = useNavigate()
  const location = useLocation()
  // @ts-ignore
  const [search, setSearch] = useState(location.state?.keyword || '')

  const initState: Params = (
    // @ts-ignore
    location.state && location.state.prevState
    ? // @ts-ignore
      (location.state.prevState as Params)
    : location.state
    ? (location.state as Params)
    : ({ limit: 20 } as Params)
  )
  const [params, dispatch] = useReducer(reducer, initState)
  const { data, error } = useSWR(['/statements', params], () => orderRepository.statement(params))
  const [searchId] = useState<{ id: number }>(location.state as { id: number })

  useEffect(() => {
    if (searchId?.id) {
      dispatch({ type: ActionType.SET_USER_ID, payload: { userId: searchId.id } })
    }
  }, [])

  useEffect(() => {
    if (error) handleOpenWithErrorMessage(error.message)
  }, [error])

  const handleSearchValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.currentTarget.value)
  }

  const onSearch = () => {
    // console.log({ search })
    dispatch({ type: ActionType.SET_KEYWORD, payload: { keyword: search } })
    const values = {
      keyword: search
    }
    navigate(
      {
        pathname: location.pathname,
        search: `?${createSearchParams(values)}`,
      },
      { replace: true, state: values}
    )
  }

  const fetchStatement = async (_params?: Params) => {
    let mergedParams = _params
    if (location.state) {
      // @ts-ignore
      mergedParams = { ...location.state, ..._params }
    }
    // @ts-ignore
    dispatch({ type: ActionType.SET_OFFSET, payload: { offset: mergedParams?.offset } })
    navigate(
      {
        pathname: location.pathname,
        // @ts-ignore
        search: `?${createSearchParams(mergedParams)}`,
      },
      // @ts-ignore
      { state: mergedParams }
    )
  }

  return (
    <ProtectedPage pageTitle={t('statement_of_account_list.statement_of_account_list')}>
      {!data && <LoadingNormal />}
      {data && (
        <>
          <HeaderStatementOfAccountList
            searchValue={search}
            handleSearchValue={handleSearchValue}
            onSearch={onSearch}
            isLoading={false}
          />
          <TableStatementOfAccountList
            data={data?.statement ? data.statement : []}
            pagination={data?.pagination}
            onPageChange={fetchStatement}
          />
        </>
      )}
    </ProtectedPage>
  )
}
